import { useState } from "react";

export function FadeImg({
  src,
  alt,
  className = "",
  ...rest
}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setLoaded(true)}
      className={`img-fade ${loaded ? "loaded" : ""} ${className}`}
      {...rest}
    />
  );
}
